import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useI18n } from '../../i18n';

const CODES = ['en', 'zh'];

export default function LanguageSwitcher({ size = 'sm', variant = 'outline-primary', className = '' }) {
  const { t, lang, changeLanguage } = useI18n();

  const labelFor = (code) => t(`common:languages.${code}`);
  const currentLabel = labelFor(lang);

  return (
    <Dropdown align="end" className={className}>
      <Dropdown.Toggle size={size} variant={variant} id="lang-switcher">
        {currentLabel}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {CODES.map((code) => (
          <Dropdown.Item key={code} active={code === lang} onClick={() => changeLanguage(code)}>
            {labelFor(code)}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
